module.exports = __webpack_public_path__ + "static/media/alert-orange-close.a6f90a41.svg";